import React from 'react';

import { GenericSelector } from '../GenericSelector';

export const PreferenceSelector = ({
  onPreferenceChange,
  preferences,
  selectedPreference,
  size = 'small'
}) => {
  return (
    <GenericSelector
      displayEmpty
      getOptionId={option => option?.value}
      getOptionLabel={option => option.label || option.value}
      onChange={onPreferenceChange}
      options={preferences}
      size={size}
      value={selectedPreference}
    />
  );
};
